import { inject, awaitRedraw } from "@dhx/ts-common/dom";
import { ICol, IRendererConfig, GridEvents, IEditor, IRow } from "../../types";
import { Combobox } from "@dhx/ts-combobox";

export class ComboboxEditor implements IEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _cell: { row: IRow, col: ICol };
	protected _config: IRendererConfig;
	protected _input: Combobox;

	constructor(row: any, col: ICol, config: IRendererConfig) {
		this._config = config;
		this._cell = { row, col };
		this._initHandlers();
	}

	endEdit(withoutSave?: boolean) {
		let value: any;
		if (!withoutSave) {
			value = this._input.getValue();
		}
		if (this._config.events.fire(GridEvents.beforeEditEnd, [value, this._cell.row, this._cell.col])) {
			document.removeEventListener("click", this._handlers.onOuterClick);
			this._handlers = {};
			this._config.events.fire(GridEvents.afterEditEnd, [value, this._cell.row, this._cell.col]);
		} else {
			this._input.focus();
		}
	}

	toHTML() {
		const content = this._cell.col.options.map((item) => {
			return {id: `${item}`, value: item};
		}) || [];

		if (!this._input) {
			this._input = new Combobox(null, {
				readonly: true,
				cellHeight: 37,
				css: "dhx_cell-editor__combobox"
			});
			this._input.data.parse(content);
			this._input.setValue(this._cell.row[this._cell.col.id]);
		}
		document.addEventListener("click", this._handlers.onOuterClick);

		this._config.$editable.editor = this;
		awaitRedraw().then(() => {
			const holderNode = this._input.getRootView().refs.holder.el;
			this._input.popup.getContainer().style.width = holderNode.offsetWidth + "px";
			this._input.popup.show(holderNode);
		});
		return inject(this._input.getRootView());
	}

	protected _initHandlers() {
		this._handlers = {
			onOuterClick: (e: Event) => {
				if (!(e.target instanceof Node && this._input.getRootNode() && this._input.getRootNode().contains(e.target))) {
					this.endEdit();
				}
			}
		};
	}
}